﻿export class Credentials {
    public loginName: string;
    public password: string;
    public userType: number;
    public selected: boolean;


    constructor() {
        this.loginName = "";
        this.password = "";
        this.userType = 0;
        this.selected = false;
    }
}


export class CredentialsResponse {
    public firstName: string;
    public lastName: string;
    public token: string;
    constructor() {
        this.firstName = "";
        this.lastName = "";
        this.token = "";
    }
}